export default __webpack_public_path__ + "static/2451-e32995a6561d07d586953605e4364af4.gif";